import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  HwDcDashboardProvider,
  HwDcDashboardStore,
} from '../../providers/hwDcDashboard';
import RecentTransactions from '../widgets/dashboards/RecentTransactions';
import RecentPayments from '../widgets/dashboards/RecentPayments';
import BenefitAmounts from '../widgets/dashboards/BenefitAmounts';


const today = new Date();

const HwDcDashboardView = () => {
  const {
    fingertipLinks,
    healthSnapshot,
    companiesMessages,
    savingsSnapshot,
    coveredFamilyMembers,
    otherCompanyBenefits,
  } = useContext(HwDcDashboardStore) || {};
  const navigate = useNavigate();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row className="d-flex justify-content-between m-0 p-0 mt-12">
        <Col className="m-0 p-0 d-flex flex-column col-12 col-lg-7 pe-lg-4">
        <BenefitAmounts
           Benefit-Amounts={BenefitAmounts}
          />
        </Col>
        <Col className="pe-lg-0 col-12 col-lg-5">
          <RecentTransactions recent-transactions={RecentTransactions}/>
        </Col>
      </Row>


      <Row className="m-0 p-0 d-flex justify-content-between">
        <Col className="m-0 p-0 mt-12 mt-lg-8 pt-lg-6 col-12 col-lg-6 pe-lg-4">
            <RecentPayments />
        </Col>
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 ps-lg-4'
          }
        >
          <FingerTipsLinks data={fingertipLinks} className="p-0 pe-5" />
        </Col>
      </Row>

      



    </Container>
  );
};

const HwDcDashboard = () => {
  return (
    <HwDcDashboardProvider>
      <HwDcDashboardView />
    </HwDcDashboardProvider>
  );
};

export default HwDcDashboard;
